export default "__VITE_ASSET__DyY6WdiV__"